export default "__VITE_ASSET__CfNE79AP__"